import React, { useEffect } from 'react';
import { Router } from '../navigation/Router';

const Landing: React.FC = () => {
  useEffect(() => Router.goToLogin(), []);
  return <></>;
};

export default Landing;
